import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import Icon from './common/icons/Icon';
import GiftSubscriptionForm from './GiftSubscriptionForm';
import { getGiftSubscriptionPrice, purchaseGiftSubscriptions } from './redux/actions';
import { formatValidationErrors, formatSubscriptionErrors } from './common/utils/getApiReducer';
import { reportSubscriptionPurchase } from './common/events';

class GiftSubscription extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  state = {
    giftSubscriptionPurchased: false,
  };

  componentDidMount() {
    this.props.dispatch(getGiftSubscriptionPrice());
  }

  navigateToSubscriptionRoute = () => {
    this.props.history.push('/');
  };

  handleSubmitGiftSubscriptionForm = values => {
    return new Promise((resolve, reject) => {
      window.Stripe.card.createToken(
        {
          name: values.name.trim(),
          number: values.number.replace(/[^\d]/g, ''),
          cvc: values.cvc,
          exp_month: values.exp_month,
          exp_year: values.exp_year,
          address_zip: values.postal_code,
        },
        (status, response) => {
          if (response.error) {
            reject(new SubmissionError({ [response.error.param || '_error']: response.error.message }));
          } else {
            resolve(response.id);
          }
        }
      );
    })
      .then(paymentSource => {
        const payload = {
          recipients: values.recipients,
          name: values.name,
          email: values.email,
          source: paymentSource,
          unitPrice: this.props.giftSubscriptionPrice.get('data'),
        };

        return this.props.dispatch(purchaseGiftSubscriptions(payload));
      })
      .then(action => {
        if (!action.response.ok) {
          /**
           * In the case of card decline errors, there is no validation error attached to the error object.
           * In that case, we will have to dispatch the error manually.
           *
           * This assumes that the only type of error to be thrown without any validation attached is 'card declined' errors.
           * If other error types arise, this code will have to be expanded upon.
           */
          if (action.json.validationErrors) {
            throw new SubmissionError(formatValidationErrors(action.json).toJS());
          } else {
            throw new SubmissionError(formatSubscriptionErrors(action.json).toJS());
          }
        } else {
          reportSubscriptionPurchase(
            `${(values.recipients.length * this.props.giftSubscriptionPrice.get('data') / 100).toFixed(2)}`,
            'giftsub',
            'Gift Subscription'
          );

          this.setState({ giftSubscriptionPurchased: true });
        }
      });
  };

  render() {
    const { giftSubscriptionPrice } = this.props;
    const { giftSubscriptionPurchased } = this.state;

    if (giftSubscriptionPurchased) {
      return (
        <div className="subscribe__wrapper">
          <div className="subscribe__centered">
            <h3>Thanks for your purchase!</h3>
            <p>
              Thank you for giving the gift of golf. Check your email for your receipt and gift subscription redemption
              information.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="subscribe__wrapper">
        <div className="container">
          <div className="subscribe--go-back" onClick={this.navigateToSubscriptionRoute}>
            <span className="button__back-button">
              <Icon icon="BackArrow" /> Back to Subscribe
            </span>
          </div>
          <div className="subscribe">
            <div className="subscribe__details">
              <div className="subscribe__cta">
                <h3>Give the Gift of Tathata</h3>
                <p>
                  Know someone who loves golf? With a 1-year membership to Tathata Golf, they will have unlimited access
                  to Tathata Golf Training Courses (including the <em>All-New 60-Day Training Program</em>), Tathata TV,
                  Video Library, and other member benefits.
                </p>
              </div>
              <div>
                <ul>
                  <li>
                    <Icon icon="CheckmarkCircleOutline" />Unlimited streaming of all video content
                  </li>
                  <li>
                    <Icon icon="CheckmarkCircleOutline" />Download videos for offline viewing
                  </li>
                  <li>
                    <Icon icon="CheckmarkCircleOutline" />Access to Certified Movement Specialists
                  </li>
                  <li>
                    <Icon icon="CheckmarkCircleOutline" />New Courses & TV Shows added regularly
                  </li>
                </ul>
              </div>
              <p>A Message From The Founder Of Tathata Golf</p>
              <video
                controls
                poster="https://d27vybgvtr1dba.cloudfront.net/subscribe-thumbnail.jpg"
                src="https://d27vybgvtr1dba.cloudfront.net/signup-introduction.mp4"
              />
            </div>
            <GiftSubscriptionForm
              onSubmit={this.handleSubmitGiftSubscriptionForm}
              price={giftSubscriptionPrice.get('data')}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    giftSubscriptionPrice: state.giftSubscriptionPrice,
  };
})(GiftSubscription);



// WEBPACK FOOTER //
// ./src/GiftSubscription.js